<h1 class="mb-2"><mdb-icon fas icon="tasks"></mdb-icon> Cotizaciones</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Reportes y Consultas</span>
      <span> /</span>
      <span>Cotizaciones</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="row filtros-body">
      <div class="col" style="max-width: 200px;">
        <div class="md-form">
          <input
            value=""
            type="text"
            id="rut"
            class="form-control"
            placeholder="9.999.999-9"
            required
            #rut
          />
          <label for="rut">RUT</label>
        </div>
      </div>

      <div class="col" style="max-width: 200px;">
        <div class="md-form">
          <mdb-date-picker
            [inline]="true"
            name="fechaDesde"
            [placeholder]="'Desde'"
            required
          ></mdb-date-picker>
        </div>
      </div>
      <div class="col" style="max-width: 200px;">
        <div class="md-form">
          <mdb-date-picker
            [inline]="true"
            name="fechahasta"
            [placeholder]="'Hasta'"
            required
          ></mdb-date-picker>
        </div>
      </div>
    </div>
  </div>
  <!-- FOOTER -->
  <div
    class="card-footer text-muted filtros-footer"
    style="border-top: 1px solid #dee2e6;"
  >
    <div></div>
    <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect>
      <mdb-icon fas icon="search"></mdb-icon>
      Buscar
    </button>
  </div>
</div>

<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">RUT</th>
            <th scope="col">Nombre cliente</th>
            <th scope="col">Fecha</th>
            <th scope="col">Total</th>
            <th scope="col">Estado</th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>99.999.999-9</td>
            <td>Juan Perez</td>
            <td>02/07/2020</td>
            <td>10.000</td>
            <td>
              <mdb-badge pill="true" default="true">Vencida</mdb-badge>
            </td>

            <td>
              <button
                mdbBtn
                type="button"
                color="info"
                mdbWavesEffect
                class="btn"
                size="sm"
              >
                Copiar COT
              </button>

              <button
                mdbBtn
                type="button"
                color="info"
                mdbWavesEffect
                class="btn"
                size="sm"
              >
                Reenviar E-Mail
              </button>

              <button
                mdbBtn
                type="button"
                color="info"
                mdbWavesEffect
                class="btn-actions-sm"
                size="sm"
                mdbTooltip="Ver"
                placement="right"
              >
                <mdb-icon fas icon="eye"></mdb-icon>
              </button>

              <button
                mdbBtn
                type="button"
                color="info"
                mdbWavesEffect
                class="btn-actions-sm"
                size="sm"
              >
                <mdb-icon fas icon="print"></mdb-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
